<template>
  <div class="make_main con">
    <!-- 主播选择组件 -->
    <Anchor @user="useAnchor" @mb="showAnchor(false)" @selectTemplate="selectTemplate" v-show="show_anchor"
      :show="show_anchor" />
    <!-- 多音字纠正组件 -->
    <Polyphone @setPoly="setPoly" v-if="show_ploy" :text="format_text" />
    <!-- 添加背景音乐弹框 -->
    <Bgdmusic v-model="show_bgmusic" @selectBgmusic="selectBgmusic" @clearBgmusic="clearBgmusic"></Bgdmusic>
    <!-- 逐句试听组件 -->
    <Gradatim v-if="show_gradatim" :ttsobj="obj_gradatim" @hide="show_gradatim = false" />
    <!-- 导入文案组件 -->
    <ToLead @goMake="goMakeForToLead" v-if="show_tolead" @hide="show_tolead = false" />
    <div class="make_funlist">
      <!-- 更换主播区域 -->
      <div class="make_anchor">
        <div class="flex_ali">
          <img :src="anchor.zbcover" class="anchor_avater" />
          <div>
            <p class="anchor_name">{{ anchor.speakername }}</p>
            <p class="anchor_desp overflow_hide">
              {{ anchor.zbdesp }}
            </p>
          </div>
        </div>
        <div class="anchor_swbtn" @click="showAnchorView()" style="width:100px;">
          更换主播
        </div>
      </div>
      <!-- 情绪选择区域 -->
      <div class="make_mood make_moodcon" v-if="anchor.isemotion == '1'">
        <div class="flex_ali">
          <img :src="mood.icon" class="anchor_avater" />
          <div>
            <p class="anchor_name">{{ mood.title }}</p>
            <p class="mood_desp overflow_hide">{{ mood.desp }}</p>
          </div>
        </div>
        <div>
          <img src="../../assets/images/img2/make_xiala.png" class="make_bot" />
        </div>
        <div class="make_modd_ex">
          <div class="make_modd_excon">
            <div class="make_modd_li" v-for="(item3, index) in JSON.parse(anchor.emotion)" :key="index"
              @click="mood = item3">
              <div class="flex_ali">
                <img :src="item3.icon" class="make_modd_icon" />
                <div>
                  <p class="fontS16">{{ item3.title }}</p>
                  <p class="extend_work_desp">{{ item3.desp }}</p>
                </div>
              </div>
              <div class="index_mod2_btn make_mod2_btn" :class="
                mood_audio.audiourl == item3.url ? 'index_mod2_btnact' : ''
              " @click.stop="playMood(item3.url)">
                <img src="../../assets/images/pause.png" v-if="mood_audio.audiourl == item3.url" />
                <img src="../../assets/images/play.png" v-else />
                <span>{{
                  mood_audio.audiourl == item3.url ? "暂停" : "试听"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="make_unUse" v-else>
        <img class="real_marR10" src="../../assets/images/tongyong.png" alt="" />
        <p>不支持情绪选择</p>
      </div>
      <!-- 背景音乐选择区域 -->
      <div class="make_bgmusic">
        <div class="flex_ali" v-if="bg_music.bgid">
          <img src="../../assets/images/img2/bgmusic.png" class="anchor_avater" />
          <div>
            <p class="anchor_name overflow_hide" style="width:150px">
              {{ bg_music.bgname }}
            </p>
            <p class="anchor_desp overflow_hide">
              时长：{{ formatDuring(bg_music.bgtimelen) }}
            </p>
          </div>
        </div>
        <div v-else class="make_flexDR">
          <img src="../../assets/images/img2/bgmusic.png" class="anchor_avater" />
          <div>未选择背景音乐</div>
        </div>
        <!-- <div v-else>未选择背景音乐</div> -->
        <div class="anchor_swbtn" @click="showBgMusic">
          {{ bg_music.bgid ? "更换音乐" : "选择音乐" }}
        </div>
      </div>
      <!-- 配同款区域 -->
      <div class="flex_ali make_demo" @click="show_tolead = true">
        <img src="../../assets/images/img2/make_demo.png" />
        <div>
          <p class="anchor_name">导入文案</p>
          <p class="anchor_desp overflow_hide">用图片/txt导入文案</p>
        </div>
      </div>
      <!-- 配同款区域 -->
      <!-- <router-link to="/demo"
        ><div class="flex_ali make_demo">
          <img src="../../assets/images/img2/make_demo.png" />
          <div>
            <p class="anchor_name">配同款</p>
            <p class="anchor_desp overflow_hide">模板任意选择</p>
          </div>
        </div></router-link
      > -->
      <!-- 导出作品区域 -->
      <div class="make_mood extend_work" @click="synthesisDubbing(true)">
        <div class="flex_ali">
          <img src="../../assets/images/img2/ext1.png" class="make_funicon" />
          <div>
            <p class="anchor_name">保存作品</p>
            <p class="mood_desp overflow_hide">存到账号列表</p>
          </div>
        </div>
        <!-- <div>
          <img src="../../assets/images/img2/make_xiala.png" class="make_bot" />
        </div> -->
        <!-- <div class="extend_work_ex">
          <ul class="extend_list">
            <li class="flex_ali">
              <img src="../../assets/images/img2/ext1.png" class="extend_work_icon">
              <div>
                <p class="fontS14">保存作品</p>
                <p class="extend_work_desp">存到账号列表</p>
              </div>
            </li>
            <li class="flex_ali" @click="downloadDub">
              <img src="../../assets/images/img2/ext2.png" class="extend_work_icon">
              <div>
                <p class="fontS14">导出音频</p>
                <p class="extend_work_desp">导出MP3格式</p>
              </div>
            </li>
            <li class="flex_ali">
              <img src="../../assets/images/img2/ext3.png" class="extend_work_icon">
              <div>
                <p class="fontS14">导出视频</p>
                <p class="extend_work_desp">导出MP4格式</p>
              </div>
            </li>
          </ul>
        </div> -->
      </div>
    </div>

    <div class="make_con">
      <!-- 配音效果设置区域 -->
      <div class="make_install fl">
        <p class="make_install_tit">效果设置</p>
        <div class="make_install_mod">
          <span>播放语速</span>
          <span>{{ speed }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="speed" :min="-100" :max="100"></el-slider>
        </div>
        <div class="make_install_mod">
          <span>播放语调</span>
          <span>{{ pitch }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="pitch" :min="-100" :max="100"></el-slider>
        </div>
        <div class="make_install_mod">
          <span>主播音量</span>
          <span>{{ volume }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="volume" :min="0" :max="100"></el-slider>
        </div>
        <div class="make_install_mod">
          <span>背景音乐</span>
          <span>{{ bg_volume }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="bg_volume" :min="0" :max="100"></el-slider>
        </div>
        <div class="make_install_mod">
          <span>文本播报延迟时长</span>
          <span>{{ text_delay }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="text_delay" :min="0" :max="10"></el-slider>
        </div>
        <div class="make_install_mod">
          <span>背景音乐续播时长</span>
          <span>{{ bg_continue }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="bg_continue" :min="0" :max="10"></el-slider>
        </div>
        <!-- <div class="make_install_mod">
          <span>文本循环间隔时长</span>
          <span>{{ loop_time }}</span>
        </div>
        <div class="make_install_slider">
          <el-slider v-model="loop_time" :min="0" :max="100"></el-slider>
        </div> -->
        <!-- <div class="flex_ali_h make_ismod">
          <img
            src="../../assets/images/img2/select_un.png"
            class="make_select_icon"
            v-if="is_bgcut"
            @click="is_bgcut = !is_bgcut"
          />
          <img
            src="../../assets/images/img2/select_act.png"
            class="make_select_icon"
            v-else
            @click="is_bgcut = !is_bgcut"
          />
          <span>人生播放时背景音减小</span>
        </div> -->
        <!-- <div class="flex_ali_h make_ismod">
          <img
            src="../../assets/images/img2/select_un.png"
            class="make_select_icon"
            v-if="is_bgloop"
            @click="is_bgloop = !is_bgloop"
          />
          <img
            src="../../assets/images/img2/select_act.png"
            class="make_select_icon"
            v-else
            @click="is_bgloop = !is_bgloop"
          />
          <span>文本循环至背景音结束</span>
        </div> -->
        <div class="make_install_init" @click="saveTemplate">保存模板</div>
        <div class="make_install_init" @click="defaultInstall" style="margin-top:20px;">
          恢复默认
        </div>
      </div>

      <!-- 配音文本区域 -->
      <div class="make_textview fr">
        <div class="make_textfun">
          <div class="flex_ali">
            <div class="make_textbtn make_textbtn1" v-if="anchor.pause == '1'">
              <div class="make_textbtn_con" @click="showDetpause">
                <img src="../../assets/images/img2/jishiq.png" />
                <span>插入停顿</span>
              </div>
              <div class="make_pause_con make_pause_con2" v-show="show_detpause">
                <div class="make_pause_sli">
                  <p class="flex_bet_h">
                    <span class="fontS12">停顿</span>
                    <span class="make_pause_slinum">{{ det_pause }}s</span>
                  </p>
                  <el-slider v-model="det_pause" class="make_pause_slimain" :max="10" :min="0.1" :step="0.1"
                    :show-tooltip="false"></el-slider>
                </div>
                <span style="cursor: pointer" @click.stop="insertPause">确定</span>
              </div>
            </div>

            <div class="make_textbtn make_textbtn1" v-else style="opacity: 0.5">
              <div class="make_textbtn_con">
                <img src="../../assets/images/img2/jishiq.png" />
                <span>插入停顿</span>
              </div>
              <div class="make_pause_con make_pause_con2" v-show="show_detpause">
                <div class="make_pause_sli">
                  <p class="flex_bet_h">
                    <span class="fontS12">停顿</span>
                    <span class="make_pause_slinum">{{ det_pause }}s</span>
                  </p>
                  <el-slider v-model="det_pause" class="make_pause_slimain" :max="10" :min="0.1" :step="0.1"
                    :show-tooltip="false"></el-slider>
                </div>
                <span style="cursor: pointer">确定</span>
              </div>
            </div>

            <div class="make_textbtn make_textbtn2" @click="showPloy" v-if="anchor.polyphonic == '1'">
              <img src="../../assets/images/img2/duoyinzi.png" />
              <span>多音字</span>
            </div>
            <div class="make_textbtn make_textbtn2" v-else style="opacity: 0.5">
              <img src="../../assets/images/img2/duoyinzi.png" />
              <span>多音字</span>
            </div>
            <div class="make_textbtn make_textbtn3" @click="startGradatim">
              <img src="../../assets/images/img2/lingdai.png" />
              <span>逐句试听</span>
            </div>
            <div class="make_textbtn make_textbtn4" :class="playTtsAudio.src != '' ? 'make_textbtn_play' : ''"
              @click="playTts">
              <img src="../../assets/images/play.png" v-show="playTtsAudio.src == ''" />
              <img src="../../assets/images/pause.png" v-show="playTtsAudio.src != ''" />
              <span>{{
                playTtsAudio.src == "" ? "试听效果" : "停止播放"
              }}</span>
            </div>
          </div>
          <div class="flex_ali_h">
            <span class="make_cleartext" @click="clearText">清空文本</span>
            <span class="make_textsize" onClick="test()">字数： {{ text_length }}/10000</span>
          </div>
        </div>

        <div id="make_textinp" contenteditable="true" @blur="getblur()" @input="inputText()" @focus="getFocus()"></div>
        <!-- 插入停顿弹窗 -->
        <div class="make_pause" v-if="show_pause">
          <div class="make_pause_mb" @click="show_pause = false"></div>
          <div class="make_pause_con" :style="{ top: pause_top + 'px', left: pause_left + 'px' }">
            <div class="make_pause_sli">
              <p class="flex_bet_h">
                <span class="fontS12">停顿</span>
                <span class="make_pause_slinum">{{ pause }}s</span>
              </p>
              <el-slider v-model="pause" class="make_pause_slimain" :max="10" :min="0.1" :step="0.1"
                @input="setPause"></el-slider>
            </div>
            <span @click="removePause" style="cursor: pointer">删除</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
// 主播组件
import Anchor from "../../components/anchor.vue";
// 发音纠正组件
import Polyphone from "../../components/polyphone.vue";
//背景音乐组件
import Bgdmusic from "../../components/bgdmusic.vue";
// tts播放类
import PlayTtsAudio from "../../utils/PlayTtsAudio.js";
// 列表播放类
import PlayListAudio from "../../utils/PlayListAudio.js";
// 逐句试听组件
import Gradatim from "../../components/make/gradatim.vue";
// 导入文案组件
import ToLead from "../../components/make/tolead.vue"
export default {
  components: {
    Anchor,
    Polyphone,
    Bgdmusic,
    Gradatim,
    ToLead
  },
  computed: {
    ...mapState(["anchor", "show_anchor", "show_ploy", "userinfo", "userrich"])
  },
  name: "make",
  watch: {
    $route(to, from) {
      this.stopAllMusci();
      this.initRouterData();
    }
  },
  data() {
    return {
      playTtsAudio: new PlayTtsAudio(), //tts实例化播放器对象
      mood_audio: new PlayListAudio(), //情绪播放实例化播放器对象
      pitch: 0, //主播语调
      speed: 50, //主播语速
      volume: 50, // 主播音量
      bg_volume: 50, //背景音乐音量
      text_delay: 0, //文本播报延迟时长
      bg_continue: 0, //背景音乐续播时长
      loop_time: 0, //文本循环间隔时长
      is_bgcut: false, //是否人生播放时背景音减小
      is_bgloop: false, //是否文本循环至背景音结束
      range: null, //文本框相关DOM信息
      sel: null, //文本框相关DOM信息
      ttsurl: "", //tts合成地址
      text_length: 0, // 文本长度
      mood: {}, //当前选中情绪对象
      pause: 1, //插入停顿数值
      show_pause: false, //插入停顿弹出框显示状态
      pause_top: 0, //插入停顿弹出框上边距离
      pause_left: 0, //插入停顿弹出框左边距离
      pause_id: "", //当前操作的插入停顿模块对象
      format_text: "", //格式化后用于发音纠正的文本
      act_text: "", //当前选中的文字
      show_bgmusic: false, //背景音乐选择组件显示状态
      bg_music: {}, //选择的背景音乐
      det_pause: 1, //输入框顶部插入停顿值
      show_detpause: false, //输入框顶部插入停顿显示状态
      pause_may: true, //当前是否可以插入停顿(处理点击了停顿模块，再插入时布局会混乱问题)
      show_gradatim: false, //逐句试听组件显示状态
      obj_gradatim: {}, //逐句试听tts合成相关参数
      show_tolead: false,//导入文案组件显示状态
    };
  },
  mounted() {
    this.removeCopyHtml();
    this.initRouterData();
    // 默认情绪选择
    if (this.anchor.isemotion == "1")
      this.mood = JSON.parse(this.anchor.emotion)[0];
  },
  destroyed() {
    this.stopAllMusci();
  },
  methods: {
    ...mapMutations(["showAnchor"]),
    // 开启逐句试听
    startGradatim() {
      // 格式化插入停顿字符
      let html = this.formatPause($("#make_textinp").html());
      // 去除html代码和空格
      html = this.removeHtmlCode(html);
      if (!html) {
        this.$message("文本框内容不能为空！");
        return;
      }
      this.obj_gradatim = {
        isurl: 2,
        text: html, //文本内容
        zbid: this.anchor.zbid, //主播id
        pitch: this.pitch, // 语调
        speed: this.speed, //语速 传入-100~100
        volume: this.volume, //主播音量0~100
        emotion: this.mood ? this.mood.code : "" //主播情绪
      };
      this.show_gradatim = true;
    },
    // 选择配音模板
    selectTemplate(e) {
      console.log(e);
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.qryzhubodetail;
      const loading = this.$loading({
        lock: true,
        text: "应用中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.$request.postHttp({ zbid: e.zbid }, url, decData => {
        self.$store.commit("setAnchor", decData.model);
        self.volume = e.volume;
        self.speed = e.speed;
        self.pitch = e.intonation;
        self.showAnchor(false);
        loading.close();
      });
    },
    // 保存主播模板
    saveTemplate() {
      let json = {
        zbid: this.anchor.zbid,
        headpath: this.anchor.zbcover,
        speed: this.speed,
        intonation: this.pitch,
        volume: this.volume
      };
      let url =
        this.$store.state.app_api + this.$store.state.app_url.setzbtemplate;
      const loading = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.$request.postHttp(json, url, res => {
        if (res.rc !== "0") {
          this.$message.error("保存失败");
          return;
        }
        // 节流
        setTimeout(() => {
          loading.close();
          this.$message({
            message: "保存成功",
            type: "success"
          });
        }, 1000);
      });
    },
    // 处理路由传参
    initRouterData() {
      if (this.$router.currentRoute.query.bg_music) {
        this.bg_music = this.$router.currentRoute.query.bg_music;
      }

      let router_text = this.$router.currentRoute.query.voicetext;
      console.log(this.bg_music);
      if (this.$router.currentRoute.query.workinfo) {
        // 配同款或重新编辑作品传参
        let workinfo = JSON.parse(this.$router.currentRoute.query.workinfo);
        this.speed = Number(workinfo.speechrate);
        this.volume = Number(workinfo.textvolume);
        this.bg_volume = Number(workinfo.bgvolume);
        this.text_delay = Number(workinfo.textdelaytime);
        this.bg_continue = Number(workinfo.bgdelaytime);
        this.text_length = Number(workinfo.txtnum);
        $("#make_textinp").html(workinfo.voicetext);
      } else {
        this.initInstallData();
      }
      if (router_text) {
        $("#make_textinp").html(router_text);
        this.text_length = router_text.length;
      }
    },
    clearText() {
      this.show_detpause = false;
      this.$confirm("确认清空文本?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        $("#make_textinp").html("");
      });
    },
    // 显示背景音乐
    showBgMusic() {
      this.show_detpause = false;
      this.stopAllMusci();
      this.show_bgmusic = true;
    },
    // 恢复默认设置
    defaultInstall() {
      this.show_detpause = false;
      this.volume = this.$store.state.anchor.vol;
      this.speed = this.$store.state.anchor.speed;
      this.bg_volume = 50;
      this.text_delay = 0;
      this.bg_continue = 0;
      this.pitch = this.$store.state.anchor.pitch;
    },
    // 格式化时间
    formatDuring(mss) {
      return this.$globalFun.formatDuring(mss);
    },
    // 选择背景音乐
    selectBgmusic(e) {
      this.show_bgmusic = false;
      this.bg_music = e;
    },
    // 取消背景音乐
    clearBgmusic() {
      this.show_bgmusic = false;
      this.bg_music = {};
    },
    // 发音纠正关闭事件
    setPoly(text) {
      text.replace(
        /\[(.*?秒)\]/g,
        '<span class="pause" contenteditable="false">$1</span>'
      );
      text = text.replace(
        /\[(.*?秒)\]/g,
        '<span class="pause" contenteditable="false">$1</span>'
      );
      $("#make_textinp").html(text);
      this.clickPolyphone();
      this.setPauseEvent();
    },
    // 显示主播选择组件
    showAnchorView() {
      this.show_detpause = false;
      this.stopAllMusci();
      this.$store.commit("showAnchor", true);
    },
    // 情绪播放事件
    playMood(url) {
      this.playTtsAudio.stop();
      this.mood_audio.play(url);
    },
    // 文本输入事件
    inputText() {
      let html = this.formatPause($("#make_textinp").html());
      this.text_length = html.length;
    },
    // 多音字纠正点击事件
    showPloy() {
      this.show_detpause = false;
      this.format_text = this.formatPause($("#make_textinp").html()).replace(
        /#(.*?)#/g,
        '<span class="polyphone" contenteditable="false">$1</span>'
      );
      this.$store.commit("setShowPloy", true);
    },
    // 点击试听
    playTts() {
      this.show_detpause = false;
      if (this.playTtsAudio.src == "") {
        this.synthesisDubbing(false);
      } else {
        this.playTtsAudio.stop();
      }
    },
    // 初始化设置参数
    initInstallData() {
      let time = setInterval(() => {
        if (
          this.$store.state.anchor.vol !== undefined &&
          this.$store.state.anchor.speed !== undefined
        ) {
          this.pitch = this.$store.state.anchor.pitch;
          this.volume = this.$store.state.anchor.vol;
          this.speed = this.$store.state.anchor.speed;
          clearInterval(time);
        }
      }, 500);
    },
    // 去除粘贴文本html样式
    removeCopyHtml() {
      document.getElementById("make_textinp").onpaste = function (event) {
        var e = event || window.event;
        e.preventDefault();
        e = e.originalEvent || e;
        var text = e.clipboardData
          ? e.clipboardData.getData("text/plain")
          : prompt("请在这里粘贴文本", "");
        if (e.clipboardData) {
          // 支持直接 clipboardData，则直接 OK
          document.execCommand("insertText", false, text);
        } else {
          // 不支持则取用户在 prompt 提示输入框粘贴的内容（自动去格式的）
          var sel, textRange;
          try {
            document.execCommand("ms-beginUndoUnit", false, null); // 开始给 IE 增加撤回功能
          } catch (e) { }
          if (document.selection) {
            // IE9以下支持：document.selection
            textRange = document.selection.createRange();
            textRange.text = text;
            textRange.collapse(false); // 取消选择
            textRange.select(); // 重新选择
          } else if (window.getSelection) {
            // IE9以上、Firefox、Safari、Chrome和Opera支持：window.getSelection()
            sel = window.getSelection();
            var range = sel.getRangeAt(0);
            range.deleteContents(); // 删除 range 的内容
            var textNode = document.createTextNode(text);
            range.insertNode(textNode); // 向 range 插入 text 节点
            range.selectNodeContents(textNode); // 选中 text 节点
            sel.removeAllRanges(); // 删除选区中所有的 range
            sel.addRange(range); // 向选区增加刚才处理后的 range（只含 text 节点）
          }
          try {
            document.execCommand("ms-endUndoUnit", false, null); // 结束给 IE 增加撤回功能
          } catch (e) { }
        }
      };
    },
    // 在指定位置插入内容
    insertHtmlAtCaret(html) {
      if (window.getSelection) {
        if (this.sel.getRangeAt && this.sel.rangeCount) {
          var el = document.createElement("div");
          el.innerHTML = html;
          var frag = document.createDocumentFragment(),
            node,
            lastNode;
          while ((node = el.firstChild)) {
            lastNode = frag.appendChild(node);
          }
          this.range.insertNode(frag);
          // Preserve the selection
          if (lastNode) {
            this.range = this.range.cloneRange();
            this.range.setStartAfter(lastNode);
            this.range.collapse(true);
            this.sel.removeAllRanges();
            this.sel.addRange(this.range);
          }
        }
      } else if (document.selection && document.selection.type != "Control") {
        // IE < 9
        document.selection.createRange().pasteHTML(html);
      }
    },
    // 文本输入框失去光标事件
    getblur() {
      this.sel = window.getSelection();
      this.range = this.sel.getRangeAt(0);
    },
    getFocus() {
      this.pause_may = true;
    },
    // 使用主播
    useAnchor(item) {
      this.volume = item.vol;
      this.speed = item.speed;
      this.pitch = item.pitch;
      this.$store.commit("showAnchor", false);
      if (item.isemotion == "1") this.mood = JSON.parse(item.emotion)[0];
    },
    // 去除文本的html标签和空格
    removeHtmlCode(html) {
      // return html
      let diction = this.anchor.diction;
      if(diction == "en"){
          html = html
          .replace(/<[^>]+>/g, "")
          .replace(/&nbsp;/g, "");
      }else{
        html = html
          .replace(/<[^>]+>/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/\s*/g, "");
      }
      console.log("html0",this.anchor.diction);
      console.log("html",html);
      return html;
    },
    // 格式化插入停顿和发音纠正字符
    formatPause(html) {
      let newhtml = html
        .replace(
          /<span class="pause" contenteditable="false">(.*?秒)<\/span>/g,
          "[$1]"
        )
        .replace(
          /<span class="polyphone" contenteditable="false">(.*?)<\/span>/g,
          "#$1#"
        );
      return this.removeHtmlCode(newhtml);
    },
    // 验证vip状态权限(保存)
    judgeVipState() {
      // 合成文本长度
      let text_length = Number(this.text_length);
      // 是否是普通会员
      let isvalidvip = this.userrich.isvalidvip == "1";
      // 是否是超级会员
      let isvalidsvip = this.userrich.isvalidsvip == "1";
      // 配音主播是否是金牌主播
      let feature = this.anchor.feature == "1";
      if (!isvalidvip && !isvalidsvip && !feature && text_length > 300) {
        //普通用户使用普通主播，字数大于300
        this.$globalFun.goToOpenVip(
          this,
          "非会员使用普通主播限制300个字，请简化文字，或开通会员。"
        );
        return false;
      } else if (!isvalidsvip && feature) {
        //不是超级VIP使用金牌主播
        this.$globalFun.goToOpenVip(
          this,
          "非超级会员无法合成金牌主播，请开通会员。"
        );
        return false;
      } else {
        return true;
      }
    },
    // 验证vip状态权限(试听)
    judgeVipStateListen(html) {
      // 合成文本长度
      let text_length = Number(this.text_length);
      // 是否是普通会员
      let isvalidvip = this.userrich.isvalidvip == "1";
      // 是否是超级会员
      let isvalidsvip = this.userrich.isvalidsvip == "1";
      // 配音主播是否是金牌主播
      let feature = this.anchor.feature == "1";
      if (!isvalidvip && !isvalidsvip && !feature && text_length > 300) {
        this.play_type = "1";
        return html.slice(0, 299);
      } else if (!isvalidsvip && feature && text_length > 100) {
        this.play_type = "2";
        return html.slice(0, 99);
      } else {
        this.play_type = "0";
        return html;
      }
    },
    //合成配音
    synthesisDubbing(issave) {
      const self = this;
      this.show_detpause = false;
      this.stopAllMusci();
      // 判断登录状态
      if (this.$globalFun.judgeNotLogin(this)) return;
      // 会员权益逻辑处理(保存)
      if (issave && !this.judgeVipState()) return;
      // 格式化插入停顿字符
      let html = this.formatPause($("#make_textinp").html());
      // 去除html代码和空格
      html = this.removeHtmlCode(html);
      // 限制合成字数
      if (Number(this.text_length) > 10000) {
        this.$alert("合成字数不能超过10000字", "提示", {
          confirmButtonText: "确定"
        });
        return;
      }
      // 会员权益逻辑处理(试听)
      if (!issave) {
        html = this.judgeVipStateListen(html);
      }
      if (html.length == 0) {
        this.$message({
          message: "配音内容不能为空！",
          type: "warning"
        });
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "生成配音中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "make_loding"
      });
      let json = {
        isurl: 2,
        text: html, //文本内容
        zbid: this.anchor.zbid, //主播id
        pitch: this.pitch, // 语调
        speed: this.speed, //语速 传入-100~100
        volume: this.volume, //主播音量0~100
        emotion: this.mood ? this.mood.code : "" //主播情绪
      };
      let url = this.$store.state.app_api + this.$store.state.app_url.synctts;
      this.$request.postHttp(json, url, response => {
        loading.close();
        if (response.rc === "3100") {
          self.$store.commit("setShowLogin", true);
          self.$store.commit("setLoginState", false);
          self.$message({
            message: "您的设备码已过期，请前往小程序重新生成！",
            type: "warning"
          });
          return;
        }
        self.ttsurl = response.model.audiourl;
        if (issave && self.bg_music.bgid) {
          // 有背景音乐先混音再保存作品
          self.fusionBgMusicForTts(self.ttsurl, self.saveTts);
          return;
        } else if (issave && !self.bg_music.bgid) {
          // 没有背景音乐直接保存作品
          self.saveTts();
          return;
        }
        // 有背景音乐试听作品
        if (self.bg_music.bgid) {
          self.playTtsAudio.setBgVolume(self.bg_volume);
          self.playTtsAudio.haveBgPlay(
            self.ttsurl,
            self.bg_music.bgmusicurl,
            self.bg_continue,
            self.text_delay
          );
          return;
        }
        self.playTtsAudio.play(response.model.audiourl, () => {
          if (self.play_type === "2") {
            self.$alert(
              "不是超级VIP使用金牌主播，试听限制100字，如需更好体验，请前往小程序开通会员。",
              "提示",
              {
                confirmButtonText: "确定"
              }
            );
          } else if (self.play_type === "1") {
            self.$alert(
              "普通用户试听限制300字，如需更好体验，请前往小程序开通会员。",
              "提示",
              {
                confirmButtonText: "确定"
              }
            );
          }
        });
      });
    },
    // 背景音混音
    fusionBgMusicForTts(mp3url, callback) {
      /*
      mp3url-tts音频地址
      */
      let self = this;
      let json = {
        mp3url: mp3url,
        bgid: this.bg_music.bgid,
        bgdelaytime: this.bg_continue,
        textdelaytime: this.text_delay,
        bgvolume: this.bg_volume
      };
      let url =
        self.$store.state.app_api + self.$store.state.app_url.ttsmixbgmapp;
      const loading = this.$loading({
        lock: true,
        text: "背景音合成中...",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.3)",
        customClass: "make_loding"
      });
      self.$request.postHttp(json, url, response => {
        loading.close();
        self.ttsurl = response.model.mp3url;
        callback();
      });
    },
    // 保存作品
    saveTts() {
      const loading = this.$loading({
        lock: true,
        text: "保存作品中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.3)",
        customClass: "make_loding"
      });
      this.stopAllMusci();
      let text = this.formatPause($("#make_textinp").html());
      let json = {
        list: [
          {
            wktype: "1",
            wkname: text.substring(0, 6),
            musicpath: this.ttsurl,
            headpath: this.$store.state.anchor.zbcover,
            voiceauthor: this.$store.state.anchor.speakername,
            speakercode: this.$store.state.anchor.speakercode,
            zbid: this.$store.state.anchor.zbid,
            intonation: this.pitch, // 语调
            speechrate: this.speed,
            voicetext: text,
            textvolume: this.volume,
            textdelaytime: this.text_delay,
            bgname: this.bg_music !== {} ? this.bg_music.bgname : "",
            bgmusic: this.bg_music !== {} ? this.bg_music.bgmusicurl : "",
            bgvolume: this.bg_volume,
            bgdelaytime: this.bg_continue
          }
        ]
      };
      let url = this.$store.state.app_api + this.$store.state.app_url.crtwork;
      this.$request.postHttp(json, url, decData => {
        console.log("保存", decData);
        if (decData.rc !== "0") {
          this.$message({ message: "保存失败", type: "success" });
          return;
        }
        loading.close();
        this.$message({ message: "保存成功", type: "success" });
        this.$router.push(`/user/userworks`);
      });
    },
    // 停止所有音频
    stopAllMusci() {
      this.playTtsAudio.stop();
      this.mood_audio.stop();
    },
    // 显示插入停顿滑块
    showDetpause() {
      if (!this.pause_may) {
        this.$message({ message: "请选择插入停顿的位置" });
        return;
      }
      this.show_detpause = !this.show_detpause;
    },
    // 插入停顿
    insertPause() {
      // 插入停顿html代码
      let html = `<span class="pause" contenteditable="false">${this.det_pause.toFixed(
        1
      )}秒</span>`;
      this.insertHtmlAtCaret(html);
      this.show_detpause = false;
      this.setPauseEvent();
    },
    // 给每个插入停顿块添加修改停顿值事件
    setPauseEvent() {
      let self = this;
      // jquery代码(可以改为原生)
      $(".pause").unbind("click");
      $(".pause").click(function () {
        self.pause_may = false;
        self.pause = Number(
          $(this)
            .text()
            .replace("秒", "")
        );
        // 暂存当前操作的插入停顿的DOM对象
        self.pause_id = $(this);
        self.pause_top = $(this).offset().top + 35;
        self.pause_left = $(this).offset().left;
        self.show_pause = true;
      });
    },
    // 点击了多音字不允许插入停顿
    clickPolyphone() {
      let self = this;
      $(".polyphone").unbind("click");
      $(".polyphone").click(function () {
        self.pause_may = false;
      });
    },
    // 滑块滑动设置的停顿模块停顿值
    setPause(e) {
      // jquery代码(可以改为原生)
      this.pause_id.text(e.toFixed(1) + "秒");
    },
    // 删除点击的停顿块
    removePause() {
      // jquery代码(可以改为原生)
      this.pause_id.remove();
      this.show_pause = false;
    },
    // 在字符串指定位置插入字符
    insertStr(soure, start, newStr) {
      // soure为原字符串,start为将要插入字符的位置，newStr为要插入的字符
      return soure.slice(0, start) + newStr + soure.slice(start);
    },
    // 导入文案立即配音事件
    goMakeForToLead(text) {
      this.show_tolead = false
      $("#make_textinp").html(text);
    }
  }
};
</script>
<style>
@import url("../../assets/css/make.css");
</style>



// WEBPACK FOOTER //
// src/view/dubbing/make.vue